import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, OnDestroy, ViewChild, OnInit, Input, isDevMode } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectHotelBookingData, selectWHasComment } from 'app/widget/state';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import { WidgetService } from 'app/widget/services/index.service';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { filter, map, Observable, tap } from 'rxjs';
import { routeTransition } from 'app/route.transition';
import * as wStateActions from 'app/widget/state/actions';
import { WidgetData } from 'app/widget/state/index.types';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-main',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        ...TAIGA_UI_MODULES,
        TranslateModule
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    animations: [
        routeTransition,
      ]
})
export class MainComponent implements OnInit, OnDestroy {

    @Input() widgetKey!: string;
    @Input() isMobile?: boolean;
    @ViewChild("self")
    self: ElementRef | undefined;

    store$ = inject(Store);
    animationTrigger$: Observable<string> = this.router.events.pipe(filter(e => e instanceof NavigationEnd ), map( (event: any)=> event.urlAfterRedirects));

    selectWHasComment$: Observable<boolean> = this.store$.select(selectWHasComment);
    tinyView$ = this.store$.select(selectHotelBookingData).pipe(map(hd => !!hd))

    observer: any;
    ready: boolean | null = null

    constructor( private widgetService: WidgetService, protected router: Router ){}

    openMobileSeach(){
        this.store$.dispatch(wStateActions.MobileSearchVisibility({visible: true}));
    }

    openSearchPanel(){
        if(document.body.classList.contains('minimize') == false)
        this.store$.dispatch(wStateActions.SearchPanelVisibility({open: true}));
    }

    ngOnInit(): void {
        if(isDevMode()) console.log('isDevMode');
        this.widgetService.getIWidgetData<WidgetData>(this.widgetKey)
        .pipe(
            tap( (data) => {
                if(Object.keys(data).length){
                    this.store$.dispatch(wStateActions.WidgetDataLoaded({data}));
                    this.ready = true
                }
                else this.ready = false
            })
        ).subscribe();
    }

    ngAfterViewInit(){
        if(this.isMobile) this.self?.nativeElement.ownerDocument.body.classList.add('isMobile');
        this.observer =  new ResizeObserver(entries => {
            const {target}: any = entries[0];
            const offset = {height: target.scrollHeight, width: target.scrollWidth};
            this.store$.dispatch(wStateActions.OffsetChanged({offset}))
        });
        this.observer.observe(this.self?.nativeElement);
    }

    ngOnDestroy() {
        this.observer.unobserve(this.self?.nativeElement);
    }

    maximize(){
        this.store$.dispatch(wStateActions.Maximize());
      }
}
